import { Injectable } from '@angular/core';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import { RoutingHelpersService } from '@polaris-customerweb/sharedcomponents.shared';

type CommonLinks = {
    accessories?: string;
    apparel?: string;
    garage: string;
    maintenance: string;
    manual: string;
    parts?: string;
    vehicles?: string;
    support?: string;
    ridersGroup?: string;
    avalanche?: string;
    piddFaqs?: string;
    piddFaqsEpi?: string;
    polaris?: string;
};

type BrandInfo = {
    id: string;
    links: CommonLinks;
};

type BrandLinks = {
    ace: BrandInfo;
    gem: BrandInfo;
    general: BrandInfo;
    indian: BrandInfo;
    polaris: BrandInfo;
    ranger: BrandInfo;
    rzr: BrandInfo;
    slingshot: BrandInfo;
    snow: BrandInfo;
    sportsman: BrandInfo;
    victory: BrandInfo;
};

const brandLinks: BrandLinks = {
    ace: {
        id: 'ace',
        links: {
            accessories:
                'http://www.polaris.com/en-us/ace-atv/shop/accessories',
            apparel: 'http://www.polaris.com/en-us/ace-atv/shop/apparel',
            garage: 'https://www.polaris.com/en-us/account/my-garage/',
            maintenance:
                'http://www.polaris.com/en-us/ace-atv/shop/maintenance',
            manual: 'http://www.polaris.com/en-us/atv-ranger-rzr/owners-manual',
            parts: 'http://www.polaris.com/en-us/ace-atv/shop/parts',
            vehicles: 'http://www.polaris.com/en-us/ace-atv/choose-model',
        },
    },
    gem: {
        id: 'gem',
        links: {
            accessories:
                'http://www.polaris.com/en-us/gem-electric-car/shop/accessories',
            garage: 'https://gem.polaris.com/en-us/account/my-garage/',
            maintenance:
                'http://www.polaris.com/en-us/gem-electric-car/shop/maintenance',
            manual: 'http://www.polaris.com/en-us/gem-electric-car/owner-manuals',
            parts: 'http://www.polaris.com/en-us/gem-electric-car',
            support: 'http://www.polaris.com/en-us/company/contact',
            vehicles: 'http://www.polaris.com/en-us/gem-electric-car/vehicles',
        },
    },
    general: {
        id: 'general',
        links: {
            accessories:
                'http://www.polaris.com/en-us/general-utv/shop/accessories',
            apparel: 'http://www.polaris.com/en-us/general-utv/shop/apparel',
            garage: 'https://www.polaris.com/en-us/account/my-garage/',
            maintenance:
                'http://www.polaris.com/en-us/general-utv/shop/maintenance',
            manual: 'http://www.polaris.com/en-us/atv-ranger-rzr/owners-manual',
            parts: 'http://www.polaris.com/en-us/general-utv/shop/parts',
            vehicles: 'http://www.polaris.com/en-us/general-utv/choose-model',
        },
    },
    indian: {
        id: 'indian',
        links: {
            accessories:
                'http://www.indianmotorcycle.com/en-us/shop/accessories',
            apparel: 'http://www.indianmotorcycle.com/en-us/shop/apparel',
            garage: 'https://www.indianmotorcycle.com/en-us/account/my-garage/',
            maintenance:
                'http://www.indianmotorcycle.com/en-us/shop/maintenance',
            manual: 'http://www.indianmotorcycle.com/en-us/owner-resources',
            parts: 'http://www.indianmotorcycle.com/en-us/parts',
            ridersGroup: 'http://www.indianmotorcycle.com/en-us/riders-group',
            vehicles: 'http://www.indianmotorcycle.com/en-us/motorcycles',
        },
    },
    polaris: {
        id: 'polaris',
        links: {
            garage: 'https://www.polaris.com/en-us/account/my-garage/',
            maintenance: 'http://www.polaris.com/en-us/shop',
            manual: 'http://www.polaris.com/en-us/rider-support/owners-manual',
            polaris: 'http://www.polaris.com/en-us',
        },
    },
    ranger: {
        id: 'ranger',
        links: {
            accessories:
                'http://www.polaris.com/en-us/ranger-utv/shop/accessories',
            apparel: 'http://www.polaris.com/en-us/ranger-utv/shop/apparel',
            garage: 'https://ranger.polaris.com/en-us/account/my-garage/',
            maintenance:
                'http://www.polaris.com/en-us/ranger-utv/shop/maintenance',
            manual: 'http://www.polaris.com/en-us/atv-ranger-rzr/owners-manual',
            parts: 'http://www.polaris.com/en-us/ranger-utv/shop/parts',
            vehicles: 'http://www.polaris.com/en-us/ranger-utv/choose-model',
        },
    },
    rzr: {
        id: 'rzr',
        links: {
            accessories:
                'https://www.polaris.com/en-us/off-road/rzr/accessories',
            apparel: 'https://www.polaris.com/en-us/off-road/apparel',
            garage: 'https://rzr.polaris.com/en-us/account/my-garage/',
            maintenance:
                'https://www.polaris.com/en-us/off-road/rzr/maintenance',
            manual: 'http://www.polaris.com/en-us/atv-ranger-rzr/owners-manual',
            parts: 'http://www.polaris.com/en-us/off-road/rzr/parts',
            vehicles: 'https://www.polaris.com/en-us/off-road/rzr/models',
        },
    },
    slingshot: {
        id: 'slingshot',
        links: {
            accessories:
                'http://www.polaris.com/en-us/slingshot/shop/accessories',
            apparel: 'http://www.polaris.com/en-us/slingshot/shop/apparel',
            garage: 'https://slingshot.polaris.com/en-us/account/my-garage/',
            maintenance:
                'https://slingshot.polaris.com/en-us/shop/maintenance/',
            manual: 'http://www.polaris.com/en-us/rider-support/owners-manual',
            parts: 'https://slingshot.polaris.com/en-us/parts/',
            ridersGroup: 'https://slingshot.polaris.com/en-us/club-slingshot',
            vehicles: 'http://www.polaris.com/en-us/slingshot',
        },
    },
    snow: {
        id: 'snow',
        links: {
            accessories:
                'http://www.polaris.com/en-us/snowmobiles/shop/accessories',
            apparel: 'http://www.polaris.com/en-us/snowmobiles/shop/apparel',
            avalanche: 'http://www.avalanche.org/',
            garage: 'https://www.polaris.com/en-us/account/my-garage/',
            maintenance:
                'http://www.polaris.com/en-us/snowmobiles/shop/maintenance',
            manual: 'http://www.polaris.com/en-us/rider-support/owners-manual',
            parts: 'http://www.polaris.com/en-us/snowmobiles/shop/parts',
            piddFaqs: '/pidd/faqs',
            piddFaqsEpi: '/en-us/app/pidd/faqs',
            vehicles: 'http://www.polaris.com/en-us/snowmobiles/choose',
        },
    },
    sportsman: {
        id: 'sportsman',
        links: {
            accessories:
                'http://www.polaris.com/en-us/atv-quad/shop/accessories',
            apparel: 'http://www.polaris.com/en-us/atv-quad/shop/apparel',
            garage: 'https://www.polaris.com/en-us/account/my-garage/',
            maintenance:
                'http://www.polaris.com/en-us/atv-quad/shop/maintenance',
            manual: 'http://www.polaris.com/en-us/atv-ranger-rzr/owners-manual',
            parts: 'http://www.polaris.com/en-us/atv-quad/shop/parts',
            vehicles: 'http://www.polaris.com/en-us/atv-quad/choose-model',
        },
    },
    victory: {
        id: 'victory',
        links: {
            accessories:
                'http://www.victorymotorcycles.com/en-us/shop/accessories',
            apparel: 'http://www.victorymotorcycles.com/en-us/shop/apparel',
            garage: 'https://www.polaris.com/en-us/account/my-garage/',
            maintenance:
                'http://www.victorymotorcycles.com/en-us/shop/maintenance',
            manual: 'http://www.victorymotorcycles.com/en-us/owners-manuals',
            parts: 'http://www.victorymotorcycles.com/en-us/shop/parts',
            support: 'http://www.polaris.com/en-us/company/contact',
            vehicles: 'http://www.victorymotorcycles.com/en-us/motorcycles',
        },
    },
};

@Injectable({ providedIn: 'root' })
export class ThemeService {
    constructor(
        private configService: ConfigService,
        private routingHelpersService: RoutingHelpersService
    ) {}

    getBrandLink(brand: string, link: string): string {
        if (brand === 'offroad') {
            brand = 'polaris';
        }

        if (link === 'piddManual') {
            return this.routingHelpersService.combineUrl(
                this.configService.displayUpdatesUrl,
                'manual/pidd-43/PIDD-Owners-Manual.pdf'
            );
        } else if (link === 'ridecommandManual') {
            return this.routingHelpersService.combineUrl(
                this.configService.displayUpdatesUrl,
                'manual/ridecommand/Ride-Command-Owners-Manual.pdf'
            );
        } else if (link === 'support') {
            return this.getSupportUrl(brand);
        } else if (link === 'home') {
            return this.getHomeUrl();
        }

        return this.getLinkUrl(brand, link);
    }

    private getHomeUrl(): string {
        if (this.configService.isEmbedded) {
            return this.routingHelpersService.combineUrl(
                this.configService.siteUrl,
                'home/'
            );
        }

        return '/home';
    }

    private getLinkUrl(brand: string, link: string): string {
        let url = '';
        const linksForBrand: BrandInfo = brandLinks[brand as keyof BrandLinks];

        if (!linksForBrand) {
            return '';
        }

        if (this.configService.isEmbedded) {
            url =
                (linksForBrand.links[link + 'Epi'] as string | undefined) ??
                (linksForBrand.links[link] as string | undefined) ??
                '';
        }

        return url.includes('en-us')
            ? this.routingHelpersService.getUrlWithCulture(url)
            : url;
    }

    private getSupportUrl(brand: string): string {
        if (brand === 'gem' && brandLinks.gem.links.support) {
            return this.routingHelpersService.getUrlWithCulture(
                brandLinks.gem.links.support
            );
        } else if (brand === 'victory' && brandLinks.victory.links.support) {
            return this.routingHelpersService.getUrlWithCulture(
                brandLinks.victory.links.support
            );
        }

        if (this.configService.isEmbedded) {
            return this.routingHelpersService.combineUrl(
                this.configService.siteUrl,
                'support/'
            );
        }

        return '/support';
    }
}
